import React from 'react';
import Component from '../../components/Component';
import DbInfo from '../../dbinfo';
import * as Constants from '../../constants';
import Toolbar from '../../components/Toolbar';
import {Button} from 'react-bootstrap';
import {RxForm, FormManager, FormField, FormRow, Multiform} from 'reactis-forms';
import {TextInput, TextArea, DatePicker, RadioList, FileUpload, ImageUpload, Select, ToggleButton, Checkbox, Number} from 'reactis-inputs';
import {actions as formactions} from 'reactis-forms';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {AlertWindow, ConfirmWindow} from 'reactis-modal';
import FormDB from '../../components/FormDB';
import {Loader, LoadingButton} from 'reactis-loader';
import ActionButton from '../../components/ActionButton';
import SaveButton from '../../components/SaveButton';
import IconCheckbox from "../../components/Form/IconCheckbox";
import ImageGallery from "../../components/Form/ImageGallery";
import Renderers from "../../helpers/Renderers";
import ButtonToolbar from "../../components/ButtonToolbar";
import immutable from "immutable";
import DocumentList from "../../containers/Document/PickerList";
import {ModalWindow} from 'reactis-modal';
import DocumentSubform from "../../containers/Document/DocumentSubform";

@connect((state, props) => {
		return {
			form: state.forms.get('tab_' + props.tabid)
		};
	},
	(dispatch) => {
		return {actions: bindActionCreators(formactions, dispatch)};
	}, null, {withRef: true })
export default class Form extends FormDB {

	constructor(props, context) {
		super(props, context);

		this.api = {
			fetch: 'etrainingtype.fetch',
			save: 'etrainingtype.save',
			remove: 'etrainingtype.delete'
		};

		this.changeEvent = 'etrainingtype.change';

		this.messages = {
			remove: 'Opravdu si přejete druh odstranit?',
			notfound: 'Druh nenalezen!'
		};

		this.schema = {
			title: {
				class: TextInput,
				label: 'Název',
				autoFocus: !props.id,
				rules: {
					presence: {message: 'Název je povinná položka!'}
				}
			},
			code: {
				class: TextInput,
				label: 'Kód',
			},
			abbr: {
				class: TextInput,
				label: 'Zkratka',
				rules: {
					presence: {message: 'Zkratka je povinná položka!'}
				}
			},
			description: {
				class: TextArea,
				label: 'Popis',
			},
			price: {
				class: Number,
				label: 'Cena',
			},
			basic: {
				class: IconCheckbox,
				label: 'Základní školení',
				help: 'Nejpůjde objednat řidičum, kteří již mají nějaké oprávnění'
			},
			praxe: {
				class: IconCheckbox,
				label: 'S praktickým zácvikem'
			},
			/*price_praxe: {
				class: Number,
				label: 'Cena za praktický zácvik'
			},
			price_praxe_verify: {
				class: Number,
				label: 'Cena za ověření zácviku'
			},*/
			re: {
				class: IconCheckbox,
				label: 'Opakované školení',
			},
			programme: {
				class: TextArea,
				label: 'Program',
				style: {
					height: 350
				}
			},
			training_text: {
				class: TextArea,
				label: 'Zvl. bod',
				style: {
					height: 100
				}
			},
			/*op_1: {
				class: ToggleButton,
				title: 'I.',
				value: true
			},
			op_2: {
				class: ToggleButton,
				title: 'II.',
				value: true

			},
			op_a: {
				class: ToggleButton,
				title: 'A',
				value: true
			},
			op_b: {
				class: ToggleButton,
				title: 'B',
				value: true
			},
			op_c: {
				class: ToggleButton,
				title: 'C',
				value: true
			},
			op_d: {
				class: ToggleButton,
				title: 'D',
				value: true
			},
			op_e: {
				class: ToggleButton,
				title: 'E',
				value: true
			},
			op_f: {
				class: ToggleButton,
				title: 'F',
				value: true
			},
			op_g: {
				class: ToggleButton,
				title: 'G',
				value: true
			},
			op_w1: {
				class: ToggleButton,
				title: 'W1',
				value: true
			},
			op_w2: {
				class: ToggleButton,
				title: 'W2',
				value: true
			},
			op_m: {
				class: ToggleButton,
				title: 'M',
				value: true
			},
			op_z: {
				class: ToggleButton,
				title: 'Z',
				value: true
			},*/
			/*documents: {
				class: Multiform,
				className: 'drivers multiform',
				label: 'Studijní materiály',
				addLabel: false,
				showHeader: false,
				subform: DocumentSubform,
				schema: {
					title: {
						class: TextInput,
						label: 'Příjmení'
					}
				}
			},*/
			images: {
				class: ImageGallery,
				label: 'Fotogalerie'
			},
		};
		this.form = new FormManager(this.schema);
	}

	componentDidMount() {
		this.form.on('change', (key, value) => {
			if (key == 'title') {
				this.title = value;
			}
			this.changed = true;
		});
		super.componentDidMount();
	}

	updateTab(data) {
		this.props.updateTab({title: data.title});
	}

	handleAddDocument(document) {
			let documents = this.form.getValues().get('documents');
			if (!documents) {
				documents = immutable.List();
			}
			documents = documents.push({
				id: -Math.random(),
				document: document.id,
				title: document.title
			});
			this.form.setValue({documents: documents.toJS()});
	}

	pickDocuments() {
		this.popupDriver = new ModalWindow(null, <DocumentList onAdd={(document) => this.handleAddDocument(document)} />);
		this.popupDriver.className = 'wide950';
		this.popupDriver.show(this.context.store.dispatch);
	}


	render() {

		const loading = !!(this.props.form && this.props.form.get('saving'));
		const canEdit = true || this.user.isAllowed('user', 'update');
		const canDelete = true || this.user.isAllowed('user', 'delete');
		const isNew = !this.props.id;

		const saveCloseButton = <LoadingButton
			disabled={!canEdit}
			title="Uložit"
			loading={loading}
			onClick={()=>this.save(true)}
		/>;

		const toolbar = [
			{
				title: 'Uložit',
				icon: 'fa fa-check',
				loading: loading,
				bsStyle: 'primary',
				onClick: () => this.save(true)
			},
			{
				title: 'Uložit a pokračovat v editaci',
				icon: 'fa fa-check',
				loading: loading,
				bsStyle: 'default',
				onClick: () => this.save()
			},
			{
				title: 'Uložit a nový',
				icon: 'fa fa-file-o',
				loading: loading,
				bsStyle: 'default',
				onClick: ()=>this.save(true, false, {}, () => this.props.newTab())
			},
			{
				divider: true
			},
			{
				title: 'Odstranit',
				icon: 'fa fa-trash-o',
				bsStyle: 'danger',
				color: '#A00',
				onClick: ()=>this.remove()
			}
		];

		return (
			<div style={{position:'relative'}}>
				<Loader visible={!!(this.props.form && this.props.form.get('loading'))} />
				<RxForm ref="form" form={this.form} id={'tab_' + this.props.tabid}>
					<Toolbar title="Druh e-školení">
						<ButtonToolbar buttons={toolbar} />
					</Toolbar>
					<div className="row">
						<div className="col-xs-10">
							<table className="form">
								<tbody>
								<FormRow name="title" labelWidth={200} />
								<FormRow name="code" />
								<FormRow name="abbr" />
								{false &&
								<tr>
									<th>Třída</th>
									<td><FormField name="op_1"/> <FormField name="op_2"/> </td>
								</tr>}
								{false && <tr>
									<th>Skupina</th>
									<td>
										<FormField name="op_a"/> <FormField name="op_b"/> <FormField name="op_c"/> <FormField name="op_d"/> <FormField name="op_e"/> <FormField name="op_f"/> <FormField name="op_g"/> 											<FormField name="op_w1"/> <FormField name="op_w2"/> <FormField name="op_m"/> <FormField name="op_z"/>
									</td>
								</tr>}
								<FormRow name="description" />
								<FormRow name="images" />
								<FormRow name="price" />
								<FormRow name="basic" />
								<FormRow name="praxe" />
								<FormRow name="re" />
								{false && <FormRow label="Studijní materiály">
									<FormField name="documents" />
									<Button onClick={() => this.pickDocuments()}><span className="fa fa-hand-pointer-o position-left"></span>vybrat z dokumentů</Button>
								</FormRow>}
								<FormRow name="programme" />
								<FormRow name="training_text" />
								<FormRow className="buttons">
									{saveCloseButton}
								</FormRow>
								</tbody>
							</table>
						</div>
					</div>
				</RxForm>
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./src/containers/Etrainingtype/Form.js